export const ORDER_TYPES = [
  { id: "odd_asc", label: "Odd Numbers (Ascending)" },
  { id: "even_asc", label: "Even Numbers (Ascending)" },
  { id: "seq_asc", label: "Sequence (Ascending)" },
  { id: "odd_desc", label: "Odd Numbers (Descending)" },
  { id: "even_desc", label: "Even Numbers (Descending)" },
  { id: "seq_desc", label: "Sequence (Descending)" },
];

export const getOrderTypeLabel = (id) => {
  const orderType = ORDER_TYPES.find(type => type.id === id);
  return orderType ? orderType.label : id;
};